import { render, staticRenderFns } from "./HeroSliderMulti.vue?vue&type=template&id=45d6acd8&scoped=true&"
import script from "./HeroSliderMulti.vue?vue&type=script&lang=js&"
export * from "./HeroSliderMulti.vue?vue&type=script&lang=js&"
import style0 from "./HeroSliderMulti.vue?vue&type=style&index=0&id=45d6acd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6acd8",
  null
  
)

export default component.exports